const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/audit/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireEditOrganizationPermission } from '@/lib/queries/access/usePermissions';
export const Route = createFileRoute('/(app)/org/$org/settings/audit/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    params,
    context
  }) => {
    await requireEditOrganizationPermission(context);
    if (!context.flags.auditViewEnabled) {
      throw redirect({
        to: '/org/$org/settings',
        params: {
          org: params.org
        }
      });
    }
    return null;
  }
});